
<style type="text/css" media="screen" scoped>

.incremen-drecment-feild{
	display: inline-block;
	width:80px;
	text-align: center;
}
.method-option-box{
	width: 118px;
	height: 47px;
	background: #FFFFFF;
	box-shadow: 0px 5px 20px rgba(143, 143, 143, 0.25);
	border-radius: 10px;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	line-height: 19px;
	display: inline-block;
	text-align: center;
	vertical-align: middle;
	letter-spacing: 0.015em;
	color: #4F4D4D;
	border: 2px solid transparent !important;

}
.active-method{
	border: 2px solid #1DC895 !important;
}

#add_new_shipment_form .continue-btn{
	font-style: normal;
	font-weight: bold;
	font-size: 13px;
	line-height: 18px;
	text-align: center;
	letter-spacing: 0.065em;
	color: #FFFFFF;
}

.create-bulk-order{	
	font-weight: bold;
	font-size: 11px;
	line-height: 15px;
	letter-spacing: 0.015em;
	color: #646464;
}
.error-text{
	color:#b71c1c !important;
	font-size: 12px;
}


</style>
<template>
	<div>
		<div class="text-right">
			<span @click="$router.push({name:'bulk-shipment'})" class="cursor-pointer">

				<span class="create-bulk-order mr-3 ">{{$lang.CREATE_BULK_ORDER.toUpperCase()}}</span>
				<v-btn color="primary" fab small depressed >	
					<v-icon>mdi-plus</v-icon>
				</v-btn>
			</span>
		</div>
		<v-form ref="add_new_shipment_form"  lazy-validation class="custome-form" id="add_new_shipment_form" @submit.prevent="createShipment()" >
			<v-row class="">
				<v-col cols="12" md="4" class="pr-4 py-0">
					<p class="sub-title-text-dark mb-3">{{$lang.SHIPMENTS_DETAILS}}</p>
					<div v-if="$store.state.user_type==$keys.WAREHOUSE || $store.state.user_type==$keys.SUPER_ADMIN">
						<label>{{$lang.WHOLESALER}}</label>
						<wholesaler-select-box :wholesaler="wholesaler" @update-wholesaler="getWholesaler" />
					</div>
					<div v-if="$store.state.user_type==$keys.WAREHOUSE || $store.state.user_type==$keys.SUPER_ADMIN">
						<label>{{$lang.PICKUP_AGENT}}</label>
						<agent-select-box :agent_type="$keys.PICKUP_AGENT" :label="$keys.PICKUP_AGENT" :add_self="true"
						@update-pickup-agent="getPickupAgent" />
					</div>
					<div>
						<label>{{$lang.RETAILER}}</label>
						<retailer-select-box :retailer="retailer" @update-retailter="getRetailer" />
					</div>
					<div>
						<label>{{$lang.CHALLAN_NUMBER}}</label>
						<v-text-field
						v-model="challan_number"
						:placeholder="$lang.CHALLAN_NUMBER"
						outlined
						dense
						single-line
						height="31px"
						:rules="$rules.challanNumberRule"
						id="challan_id"
						></v-text-field>
					</div>
					<div class=" m-t-negative-10 pt-2">
						<label>{{$lang.NUMBER_OF_PACKETS}}</label>
						<div class="text-center py-4 ">
							<v-btn fab small @click="number_of_packets<1?number_of_packets=0:number_of_packets=number_of_packets-1"
							:disabled="number_of_packets==1?true:false">
							<v-icon>mdi-minus</v-icon>			
						</v-btn>
						<span class="incremen-drecment-feild">
							{{number_of_packets}}
						</span>
						<v-btn fab small @click="number_of_packets=number_of_packets+1" 
						:disabled="number_of_packets==2?true:false">
						<v-icon >mdi-plus</v-icon>			
					</v-btn>			
				</div>
				<small class="error-text error--text" v-if="number_of_packets<1">{{$messages.NO_OF_PACKET_ERROR}}</small>
			</div>

		</v-col>
		<v-col md="1" class="border-r">
		</v-col>
		<v-col cols="12" md="4" class="pr-4 py-0">
			<div class="">
				<p class="sub-title-text-dark  mb-3">{{$lang.PAYMENT_DETAILS}}</p>
				<label>{{$lang.AMOUNT}}</label>
				<v-text-field
				v-model="shipment_amount"
				:label="$lang.AMOUNT"
				:placeholder="$lang.AMOUNT"
				outlined
				dense
				single-line
				maxlength="6"
				:rules="$rules.amountRule"
				></v-text-field>
			</div>


			<div class="m-t-negative-10">
				<label>{{$lang.METHOD}}</label>
				<div class="text-center mt-3">
					<div class="method-option-box mx-3 cursor-pointer" 
					:class="payment_mode==methods[1]?'active-method':''">
					<v-btn
					color="primary"
					text
					width="117"
					height="42"
					:ripple="false"
					@click="payment_mode=methods[1]" >
					{{methods[1]}}
				</v-btn>
			</div>
			<div class="method-option-box mx-3 cursor-pointer" :class="payment_mode==methods[0]?'active-method':''">
				<v-btn  
				color="primary" 
				text
				width="117"
				height="42"
				:ripple="false"
				@click="payment_mode=methods[0]" >
				{{methods[0]}}
			</v-btn>
		</div>  
	</div>  
</div>
<div class="mt-5  text-center">
	<v-btn  color="primary" type="submit" class="mt-5 continue-btn" width="117" :loading="btn_loading">
		{{$lang.CONTINUE}}
	</v-btn>
</div>
</v-col>
</v-row>
</v-form>
</div>
</template>
<script type="text/javascript">
export default {
	components: {
		RetailerSelectBox: () => import('@/components/common-components/RetailerSelectBox.vue'),
		WholesalerSelectBox: () => import('@/components/common-components/WholesalerSelectBox.vue'),
		AgentSelectBox: () => import('@/components/common-components/AgentSelectBox.vue'),
	},
	data () {
		return {
			methods:["Cash","Credit"],
			btn_loding:false,
			/* form  inputs*/ 
			wholesaler:null,
			pickup_agent:null,
			retailer:null,
			challan_number:"",
			number_of_packets:1,
			shipment_amount:null,
			payment_mode:"Credit",
			/* error flag*/
			packet_error:false,
			btn_loading:false,

			focus_challan:false,

		}
	},
	created(){
		this.$store.dispatch('drawer/setActiveTab',this.$route.name)
		// if (this.$store.state.user_type!=this.$keys.WHOLESALER)
		this.$router.push({name:'bulk-shipment'})

	},
	methods:{

		getWholesaler(wholesaler) {
			this.wholesaler = wholesaler;
		},
		getPickupAgent(agent) {
			this.pickup_agent = agent;
		},
		getRetailer(retailer) {
			this.retailer = retailer;
			document.getElementById("challan_id").focus();

		},
		/* creating   shipment */ 
		createShipment(){
			const self=this;
			if (this.$refs.add_new_shipment_form.validate()==false)
				return false

			if (this.number_of_packets<1){
				return false
			}

			self.btn_loding=true
			var	form = new FormData();
			if (this.wholesaler)
				form.append("wholesaler_id",self.wholesaler.wholesaler_id);
			if (this.pickup_agent)
				form.append("pickup_agent_id",self.pickup_agent.id);

			form.append("retailer_id",self.retailer.retailer_id);
			form.append("challan_number",self.challan_number);
			form.append("payment_mode",self.payment_mode);
			form.append("number_of_packets",self.number_of_packets);
			form.append("shipment_amount",self.shipment_amount);


			const successHandler = (response) => {
				if (response.data.success){

					this.showSnakeBar('success',response.data.message)
					this.$router.push({name:'shipment-details',params:{shipment_id:this.encript(response.data.shipment_id)}})
				}
			};
			const finallyHandler = () => {
				self.btn_loding=false
			};
			
			this.request_POST(self,this.$urls.CREATE_SHIPMENT,form,successHandler,null,null,finallyHandler)

		}
	}
}
</script>